import * as React from 'react';
import * as HoverCardPrimitive from '@radix-ui/react-hover-card';
import classNames from 'classnames';

import style from './hover-card.module.scss';

const HoverCard = HoverCardPrimitive.Root;

const HoverCardTrigger = HoverCardPrimitive.Trigger;
const HoverCardArrow = HoverCardPrimitive.Arrow;
const HoverCardPortal = HoverCardPrimitive.Portal;

interface HoverCardContentProps extends React.ComponentPropsWithoutRef<
  typeof HoverCardPrimitive.Content
> {
  usePortal?: boolean;
}

const HoverCardContent = React.forwardRef<
  React.ElementRef<typeof HoverCardPrimitive.Content>,
  HoverCardContentProps
>(
  (
    {
      className,
      align = 'center',
      sideOffset = 4,
      usePortal = false,
      ...props
    },
    ref
  ) => {
    const content = (
      <HoverCardPrimitive.Content
        ref={ref}
        align={align}
        sideOffset={sideOffset}
        className={classNames(style.hoverCardContent, className)}
        style={usePortal ? { zIndex: 10001 } : undefined}
        {...props}
      />
    );

    if (usePortal) {
      return <HoverCardPortal>{content}</HoverCardPortal>;
    }

    return content;
  }
);
HoverCardContent.displayName = HoverCardPrimitive.Content.displayName;

export { HoverCard, HoverCardTrigger, HoverCardContent, HoverCardArrow };
